(function() {
    'use strict';
    angular.module('Filters').filter('bbaDate', ['$filter', function($filter) {
            return function(strDate, withTime, dateFormat, timeZone = null) {
                let format = dateFormat || 'DD/MM/YYYY';
                if(withTime){
                    format += ' hh:mmA';
                }
                if(strDate) {
                    let dateString;
                    if(isNaN(strDate)) {
                        if(navigator.userAgent.search('Firefox') !== -1) {
                            dateString = strDate.split('+').length !== 0 ? strDate.split('+')[0].trim() : strDate;
                        } else {
                            dateString = strDate;
                        }
                    } else {
                        dateString = strDate * 1000;
                    }

                    if(timeZone) {
                        return moment(dateString).utcOffset(timeZone).format(format);
                    }
                    return moment(dateString).format(format);
                }
                return 'N/A';
            };
        }])
})();



// WEBPACK FOOTER //
// ./js/filters/bbaDate.js